export default "__VITE_ASSET__$HEUuxCn__"